// Klik op een hoodie-kaart (Featured of Collectie) -> overlay met alle echte foto's van dat
// product uit Shopify. Hover-swap (img-a/img-b) blijft los bestaan, dit is alleen de klik.
(function () {
  var CDN = 'https://cdn.shopify.com/s/files/1/1050/5214/3946/files/';
  var PHOTOS = {
    strength: [
      'le-butin8-hero-banner-gezicht-zichtbaar.png?v=1781256351',
      'IMG_02512.jpg?v=1781336829',
      'foto_bordeua_website.jpg?v=1781336803',
      'foto1bordeaux.jpg?v=1781261343',
      'foto_2_bordeaux_c62c6920-41e5-46e0-b4b0-76f10300a814.jpg?v=1781261407',
      'foto_3_bordeaux_a5fcca2f-bab4-4b20-bf52-fb0ed9eb2f58.jpg?v=1781260827',
      'foto_5_bordeau.jpg?v=1781260750',
      'foto_6_bordeaux_e2818d59-c94a-4541-bf88-3e772e3e60e4.jpg?v=1781260850',
      'foto_4_bordeaux_801bb7b5-c5bb-4b11-8ae2-8eedf06b15d2.jpg?v=1781260835'
    ],
    believe: [
      '30982c40-1d61-4ddd-a6f0-7a0eaea0afe0.jpg?v=1782558009',
      'ea209505-8ded-491b-bb03-72d27eb30cac_d0bd2c54-ec42-4616-93a1-e4f056c446cd.jpg?v=1782558101',
      'db5472c1-87d1-4eb2-b7b2-dd748c16de88.jpg?v=1782558237',
      'zwarthoodie3_5b2472c2-de8f-402b-9994-ea80e4578576.jpg?v=1781263736',
      'zwart_hoodie_9d5c08f0-d955-40f8-82f3-48631e1e5944.jpg?v=1781262908',
      'zwart_hoodie_8.jpg?v=1781263135',
      'zwart_hoodie_4.jpg?v=1781263164',
      'zwart_hoodie_7.jpg?v=1781263178',
      'zwart_hoodie_6.jpg?v=1781263839',
      'zwart_hoodie_2.jpg?v=1781263809'
    ],
    gratitude: [
      'IMG_024.jpg?v=1781335866',
      'FOTO_8_GROEN.jpg?v=1781266169',
      'FOTO1GROEN.jpg?v=1781265508',
      'FOTO_2_GROEN.jpg?v=1781265526',
      'FOTO_6_GROEN.jpg?v=1781265619',
      'FOTO_5_GROEN.jpg?v=1781265682',
      'FOTO_3_GROEN.jpg?v=1781265689',
      'FOTO_11_GROEN.jpg?v=1781266297',
      'FOTO_GROEN.jpg?v=1781266458',
      'FOTO_GROEN_2.jpg?v=1781266460',
      'FOTO_10_GROEN.jpg?v=1781336358'
    ]
  };

  var HANDLES = {
    strength: '/products/strength-hoodie',
    believe: '/products/believe-hoodie',
    gratitude: '/products/gratitude-hoodie'
  };

  var box = document.getElementById('product-lightbox');
  var grid = document.getElementById('lightbox-grid');
  var title = document.getElementById('lightbox-title');
  if (!box) return;

  function open(product) {
    var urls = PHOTOS[product];
    if (!urls) return;
    title.textContent = product.toUpperCase();
    var shop = document.getElementById('lightbox-shop');
    if (shop && HANDLES[product]) shop.href = HANDLES[product];
    grid.replaceChildren();
    urls.forEach(function (file) {
      var img = document.createElement('img');
      img.src = CDN + file;
      img.alt = product.toUpperCase() + ' hoodie';
      img.addEventListener('click', close);
      grid.appendChild(img);
    });
    box.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    box.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-lightbox-trigger]').forEach(function (card) {
    card.addEventListener('click', function (e) {
      if (e.target.closest('.uitgelicht__heart')) return; // hartje blijft eigen actie
      open(card.getAttribute('data-product'));
    });
  });

  document.getElementById('lightbox-close').addEventListener('click', close);
  box.addEventListener('click', function (e) { if (e.target === box) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();
